import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e9210ba2")

_pushScopeId("data-v-e9210ba2")
const _hoisted_1 = { class: "title df-middle" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "checkbox mr-8" }, null, -1)
const _hoisted_3 = { class: "sub-title mt-8" }
const _hoisted_4 = { class: "exp mt-12 mb-4 df-between" }
const _hoisted_5 = { class: "exp-item flex-1 mr-4 df-between df-middle px-16 br-sm" }
const _hoisted_6 = { class: "exp-item flex-1 df-between df-middle px-16 br-sm" }
const _hoisted_7 = { class: "exp df-between" }
const _hoisted_8 = { class: "exp-item flex-1 mr-4 df-between df-middle px-16 br-sm" }
const _hoisted_9 = { class: "exp-item flex-1 df-between df-middle px-16 br-sm" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Current")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")

  return (_openBlock(), _createBlock("div", {
    class: ["br-lg item-main p-16 c-text", {'active':_ctx.item.active}],
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleChoose && _ctx.handleChoose(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_t, {
        path: _ctx.item.titleLable,
        class: "f-bold"
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.item.title), 1)
        ]),
        _: 1
      }, 8, ["path"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_t, {
        path: _ctx.item.subTitleLable,
        class: "f-md"
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.item.subTitle), 1)
        ]),
        _: 1
      }, 8, ["path"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("span", null, _toDisplayString(_ctx.item.assets[0].code), 1),
        _createVNode("span", null, _toDisplayString(_ctx.item.assets[0].leverage), 1)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("span", null, _toDisplayString(_ctx.item.assets[1].code), 1),
        _createVNode("span", null, _toDisplayString(_ctx.item.assets[1].leverage), 1)
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("span", null, _toDisplayString(_ctx.item.assets[2].code), 1),
        _createVNode("span", null, _toDisplayString(_ctx.item.assets[2].leverage), 1)
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("span", null, _toDisplayString(_ctx.item.assets[3].code), 1),
        _createVNode("span", null, _toDisplayString(_ctx.item.assets[3].leverage), 1)
      ])
    ]),
    (_ctx.item.choosed)
      ? (_openBlock(), _createBlock(_component_t, {
          key: 0,
          path: "leverage_29",
          class: "current px-8"
        }, {
          default: _withId(() => [
            _hoisted_10
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
})